<div class="pad-20">
    <h3 tsl-dialog-title i18n="@@f28ca9e533c30170bc58d5de4c17c29e9a23399f" t="f28ca9e533c30170bc58d5de4c17c29e9a23399f">
        One-time Password Required
    </h3>

    <div tsl-dialog-content>
        <p i18n="@@OnTimePasswordTaxDescription" t="OnTimePasswordTaxDescription">
            In order to gain access to this section, additional, time sensitive authentication is required. Please confirm if you wish to proceed.
        </p>
    </div>

    <div tsl-dialog-actions class="mar-10" align="end">
        <button
            tsl-button
            filled
            size="small"
            cdkFocusInitial
            (click)="closDialog(true)"
            i18n="@@4f20f2d5a6882190892e58b85f6ccbedfa737952"
            t="4f20f2d5a6882190892e58b85f6ccbedfa737952"
        >
            Yes
        </button>
        <button
            tsl-button
            color="black"
            filled
            size="small"
            (click)="closDialog(false)"
            i18n="@@3d3ae7deebc5949b0c1c78b9847886a94321d9fd"
            t="3d3ae7deebc5949b0c1c78b9847886a94321d9fd"
        >
            No
        </button>
    </div>
</div>
